// src/components/navbar/GroupCard.jsx
import React from "react";
import { FaChevronDown } from "react-icons/fa";

const GroupCard = ({ group, open, onToggle, children }) => {
  const Icon = group.icon;

  return (
    <div className="mb-2 rounded-2xl bg-slate-900/60 border border-slate-700/80 backdrop-blur-sm">
      <button
        onClick={onToggle}
        className="w-full flex flex-row-reverse items-center gap-2 px-3 py-2 text-xs sm:text-[0.8rem] text-slate-100"
      >
        <span className="flex items-center justify-center w-7 h-7 rounded-xl bg-slate-800/80">
          <Icon size={15} />
        </span>
        <span>{group.label}</span>
        <FaChevronDown
          className={`mr-auto text-[0.65rem] text-slate-300 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        className={`border-t border-slate-700/70 transition-all duration-200 origin-top ${
          open
            ? "max-h-[700px] opacity-100"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default GroupCard;
